module.exports = __webpack_public_path__ + "img/the_secret_formula.c5afa380.jpg";